import {
  locDistribution,
  patientDistribution,
  bactDistribution,
  pneuDistribution,
  moDistribution
} from '@/sui/data/caracteristics/tools'

export default {

  all: (year, estb, complete) => [
    ...locDistribution('', 'bactériémies', { estb: estb, year: year }),
    patientDistribution('', 'bactériémie', complete),
    bactDistribution('', 'bactériémies', { covid: false, included: true }),
    moDistribution('', 'bactériémies', year),
    ...locDistribution('p_', 'pneumopathies', { estb: estb, year: year }),
    patientDistribution('p_', 'pneumopathie', complete),
    pneuDistribution(false, true),
    moDistribution('p_', 'pneumopathies', year)
  ],

  bact: (year, estb, complete) => [
    ...locDistribution('', 'bactériémies', { estb: estb, year: year }),
    patientDistribution('', 'bactériémie', complete),
    bactDistribution('', 'bactériémies', { covid: false, included: true }),
    moDistribution('', 'bactériémies', year)
  ],

  pneu: (year, estb, complete) => [
    ...locDistribution('p_', 'pneumopathies', { estb: estb, year: year }),
    patientDistribution('p_', 'pneumopathie', complete),
    pneuDistribution(false, true),
    moDistribution('p_', 'pneumopathies', year)
  ]
}
